import React, { useState, useEffect } from "react"
import * as Constants from '../../utils/constants'
import { getRichiesteRimborsoInserite } from "../../services/endpoints";
import { showProgress } from "../../utils/elements";

import {
  Container,
  Row,
  Col,
  Button,
} from 'design-react-kit';

export function SibaListaRichiesteRimborso(props) {

  const [isLoading, setLoading] = useState(true);
  const [richiesteRimborsi, setRichiesteRimborsi] = useState([]);

  useEffect(() => {
    async function fetchData() {
      console.log("MM sono qua")
      let utente = sessionStorage.getItem(Constants.USER_IN_SESSION)
      let richiesteRimborsiLette = await getRichiesteRimborsoInserite(utente);
      console.log("richiesteRimborsiLette=", richiesteRimborsiLette);
      if (richiesteRimborsiLette === undefined) {
        console.log('Richieste rimborso non trovate per utente %s', utente)
        setLoading(false)
        return
      }

      let richiesteRimborsiDaVisualizzare = [];
      if (richiesteRimborsiLette.status === undefined && richiesteRimborsiLette.length > 0) {
        richiesteRimborsiLette.forEach(element => {
          let richiestaRimborso = {}
          richiestaRimborso.idRichiesta = element.progressivoRichiesta + " del " + element.dataInvio;
          richiestaRimborso.datiRimborso = element.targa + " - " + element.tipoVeicolo + " Pagamento: " +
            element.scadenza + " - " + element.validita + " mesi - " + "Causale: " + element.causaleRichiesta;
          richiestaRimborso.stato = element.statoRichiesta;
          //richiestaRimborso.causaleRichiesta = element.causaleRichiesta;
          richiesteRimborsiDaVisualizzare.push(richiestaRimborso);
          console.log("MM richieste trovate " + richiesteRimborsi.length)
        });
        setLoading(false)
        console.log("MM richieste trovate " + richiesteRimborsiDaVisualizzare.length)
        setRichiesteRimborsi(richiesteRimborsiDaVisualizzare);
      }
    }

    fetchData();
  }, []);


  const readRichieste = () => {
    return (
      <Container className="px-2 my-2" id="lista" tag="section">

        {richiesteRimborsi.length > 0 ? (
          <div>
            <h3>Richieste di rimborso inserite</h3>
            <table className="table table-striped table-sm">
              <thead className="thead-light">
                <tr>
                  <th scope="col" className="align-middle text-center">Id Richiesta</th>
                  <th scope="col" className="align-middle text-center">Dati Rimborso</th>
                  {/* <th scope="col" className="align-middle text-center">Causale</th> */}
                  <th scope="col" className="align-middle text-center">Stato</th>
                </tr>
              </thead>
              <tbody>
                {richiesteRimborsi.map((element, i) => (
                  <tr key={i}>
                    <td scope="row" className="align-middle text-center">{element.idRichiesta}</td>
                    <td className="align-middle text-center">{element.datiRimborso}</td>
                    {/* <td className="align-middle text-center">{element.causaleRichiesta}</td> */}
                    <td className="align-middle text-center">{element.stato}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <div>Nessuna richiesta di rimborso trovata</div>}

        <Container className="px-2 my-2" id="stepper-nav" tag="div">
          <Row>
            <Col>
              <div className="btn-toolbar justify-content-between" role="toolbar">
                <div className="btn-group mr-2">
                  <Button
                    className="btn btn-outline-primary"
                    icon={false}
                    size="sm"
                    tag='a'
                    href={Constants.URL_TASSAAUTO_SERVIZI_ONLINE}
                    role='button'
                  > {Constants.STR_BUTTON_RESET}
                  </Button>
                  <Button
                    className="btn btn-outline-primary"
                    icon={false}
                    size="sm"
                    tag="button"
                    onClick={props.handleBack}
                  > {Constants.STR_BUTTON_INDIETRO}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

      </Container>
    )
  }

  return (isLoading ? showProgress() : readRichieste());

}

export default SibaListaRichiesteRimborso;
